export const passwordSecret = 'lsb-wallet-#@()(#@@#@#@#)!'
export const storageSecret = 'lsb-storage-@1#)(!)@(#'
